import { render, staticRenderFns } from "./WowzaList.vue?vue&type=template&id=638a4c86&scoped=true"
import script from "./WowzaList.vue?vue&type=script&lang=js"
export * from "./WowzaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638a4c86",
  null
  
)

export default component.exports